import React from "react";

import { Link } from "gatsby";

export default function Breadcrumbs({ crumbs }) {
  return (
    <ol className="breadcrumbs">
      <li>
        <Link to="/">
          <i className="fa fa-home" />
        </Link>
      </li>
      {crumbs.map((item, idx) => (
        <li key={idx}>
          {item.link ? <Link to={item.link}>{item.label}</Link> : item.label}
        </li>
      ))}
    </ol>
  );
}
